import React, { useEffect, useState, useRef, useId, useLayoutEffect } from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { StarRating } from "./identifying";
import { useUser } from "../context/useInfo";
import SubscribePayment from "../components/Subscribe";
import { dataSecret, dataReason, creamData, fakeData } from "../config/data";
import { reviews } from "../config/data";
import CustomBtn from "../components/CustomBtn";
import PaymentModal from "../components/PaymentModal";
import amplitude from "../utils/amplitude";
import { Helmet } from "react-helmet";
import ApplePayButton from "../components/ApplePayBtn";
import PhotoSection from "../components/photoSection";
import DescriptionSolviPremium from "../components/DescriptionSolviPremium";

export default function PredictionScreen() {
  const id1 = useId();
  const id2 = useId();
  const [showFullReport, setShowFullReport] = useState(false);
  const { userData } = useUser();
  const [isOpen, setModalOpen] = useState(false);
  const subscribeRef = useRef(null);
  const [animatedValues, setAnimatedValues] = useState({
    hydration: 0,
    elasticity: 0,
    complexion: 0,
    texture: 0,
  });

  const [secondsLeft, setSecondsLeft] = useState(600);
  const sectionRef = useRef(null); // блок, за которым следим
  const [startAnimation, setStartAnimation] = useState(false);



  const bgColor = "#FC5EB2";

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartAnimation(true); // запускаем анимацию
          observer.disconnect(); // больше не нужно отслеживать
        }
      },
      { threshold: 0.4 } // сколько блока должно быть видно (40%)
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!startAnimation) return;
    const finalValues = {
      hydration: 56,
      elasticity: 43,
      complexion: 70,
      texture: 83,
    };

    const duration = 2000;

    // ДАЁМ DOM ОТРИСОВАТЬСЯ
    const timeout = setTimeout(() => {
      const startTime = performance.now();

      const animate = (time) => {
        const elapsed = time - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);

        setAnimatedValues({
          hydration: finalValues.hydration * eased,
          elasticity: finalValues.elasticity * eased,
          complexion: finalValues.complexion * eased,
          texture: finalValues.texture * eased,
        });

        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      };

      requestAnimationFrame(animate);
    }, 50); // задержка в 1 кадр

    return () => clearTimeout(timeout);
  }, [startAnimation]);
  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      amplitude.track("Prediction Screen Open");
    }
    if (secondsLeft <= 0) return;

    const intervalId = setInterval(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  // Форматируем секунды в mm:ss
  const formatTime = (secs) => {
    const minutes = Math.floor(secs / 60);
    const seconds = secs % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const scrollToSubscribe = (action) => {
    if (process.env.NODE_ENV === "production") {
      amplitude.track("Purchase Button Clicked", {
        button: action,
      });
    }

    if (subscribeRef.current) {
      subscribeRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };
  // const openPayment = (action) => {
  //   if (process.env.NODE_ENV === "production") {
  //     amplitude.track("Purchase Button Clicked", {
  //       button: action,
  //     });
  //   }
  //   setModalOpen(!isOpen);
  // };

  const shouldShowApplePay = () => {
    // Сначала проверяем поддержку Apple Pay API
    if (typeof window !== "undefined" && window.ApplePaySession) {
      return ApplePaySession.canMakePayments();
    }

    // Если API нет, проверяем по User-Agent
    const userAgent = navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod|macintosh|mac os/.test(userAgent);
  };

  const handleSubscribe = async () => {
    

    if (process.env.NODE_ENV === "production") {
      amplitude.track("Other Payment Method Button Clicked");
    }

    if (userData && Object.keys(userData).length > 0) {
      localStorage.setItem(
        "userData",
        JSON.stringify({
          ...userData,
        })
      );
    }
    const email = localStorage.getItem("email");
    localStorage.removeItem("email");
    try {
      // 1. Запрос на бэкенд
      const response = await fetch(
        "https://us-central1-ai-build-ship-stream-as-l1mzrg.cloudfunctions.net/createCheckoutSession",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            priceId: userData.selectedOption.price_id,
            email: email,
          }),
        }
      );

      const data = await response.json();

      if (!data.sessionId) {
        throw new Error("Failed to create checkout session");
      }

      // 2. Получаем Stripe и делаем редирект через sessionId

      const stripeProduction = window.Stripe(
        "pk_live_51QA7KrJM0DnG2MaAT5AlDSYQutafMAuXjZDv8XQysswJSypH0X2cIKm7yff2A6AhEdXHMjkFuHOlklYrTS3ZR2Zp00fMWhc20Y"
      );
      // const stripeSandbox = window.Stripe("pk_test_51SBXaPJqJyyIEbrVJmJFowXuKTCeQ4Sxizo5wDaFDVD7aKAV6byBx8GVv2A7QoyLl1OHjb0uMaymdIpMVr2ezyXB00aO3Y428b");
      const { error } = await stripeProduction.redirectToCheckout({
        sessionId: data.sessionId,
      });

      if (error) {
        console.error(error);
        alert(error.message);
        if (process.env.NODE_ENV === "production") {
          amplitude.track("Payment Failed", {
            email: email
          });
        }
      }
    } catch (err) {
      console.error("Stripe Checkout error:", err);
      alert(err.message);
    }
  };

  return (
    <>
      <Helmet>
        <meta name="theme-color" content={bgColor} />
        <meta
          name="apple-mobile-web-app-status-bar-style"
          content="black-translucent"
        />
      </Helmet>

      <motion.div
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -50 }}
        transition={{ duration: 0.3 }}
        className="w-full h-full flex justify-center items-center"
      >
        <div
          className="fixed left-1/2 transform h-5 bg-pinkCustom -translate-x-1/2 w-full max-w-[450px] z-50"
          style={{
            top: "calc(env(safe-area-inset-top, 0px))",
          }}
            ></div>
<div
  className="fixed left-1/2 transform -translate-x-1/2 w-full max-w-[450px] z-50 bg-pinkCustom"
  style={{
    top: "env(safe-area-inset-top, 0px)",
    height: "70px"
  }}
>
  <button
    id={id1}
    key={id1}
    className="w-full text-white py-3 px-4 text-center font-semibold text-sm hover:bg-pink-600 transition h-full flex items-center justify-center leading-tight"
    onClick={() => scrollToSubscribe('Introductory offer')}
  >
    Introductory offer expires in {formatTime(secondsLeft)}
  </button>
</div>
            <div
              className="w-full max-w-[450px] h-full px-4 bg-white rounded-lg shadow-md overflow-hidden border flex flex-col relative mt-20"
            >          
            <div  className="flex justify-center gap-2 mx-auto py-5 px-5 max-w-[350px] text-sm">
            <img
              src="/star.svg"
              alt="Skincare"
              className="w-[20px] h-[20px] object-center flex-shrink-0"
            />
            <p className="text-left text-md">
              AI Prediction based on your goals
            </p>
          </div>
          <div className="flex justify-center">
            <PhotoSection userData={userData} />
          </div>
          <div className="flex flex-wrap -mx-1 mb-8">
            <Progress label="Skin Hydration" value={56} color="bg-purple-500" />
            <Progress label="Skin Hydration" value={72} color="bg-purple-500" />
            <Progress label="Skin Elasticity" value={43} color="bg-green-500" />
            <Progress label="Skin Elasticity" value={65} color="bg-green-500" />
          </div>

          <div className="mx-auto mb-3">
            <p className="text-left text-md">
              267 people bought our plans in the last 1 hour
            </p>
          </div>

          <div className="relative overflow-visible mb-10 z-0">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={0}
              slidesPerView={2.2}
              autoplay={{ delay: 4000 }}
              className="!overflow-visible relative"
            >
              {fakeData.map((item, idx) => (
                <SwiperSlide key={idx} className="!mr-1 w-auto">
                  <div className="w-full px-2 bg-gray-50 rounded-2xl shadow border">
                    {item}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className="mx-auto mb-5">
            <h1 className="text-lg md:text-xl font-semibold">
              Get Started with Special Pricing
            </h1>
          </div>
          <div ref={subscribeRef}>
            <SubscribePayment />
          </div>

          <div className="mx-auto mb-3">
            <p className="text-left text-md line-clamp-none underline">
              30-day money-back guarantee
            </p>
          </div>

          {shouldShowApplePay() ? (
            <div className="flex flex-col items-center">
              <ApplePayButton key={userData.selectedOption?.price_id} />
              <button onClick={() => handleSubscribe()} className="underline">
                Pay with other payment methods
              </button>
            </div>
          ) : (
            <CustomBtn
              text={"Get My Plan"}
              handleClick={() => handleSubscribe()}
              isSelected={!userData.selectedOption}
            />
          )}
          


          <DescriptionSolviPremium />
          <div
            className="bg-white rounded-md w-full max-w-md p-4 mx-auto mb-5 text-center relative"
            style={{
              boxShadow:
                "0 -2px 4px rgba(0, 0, 0, 0.2), 0 1px 2px rgba(0, 0, 0, 0.05)",
            }}
          >
            <h1 className="text-lg md:text-xl font-semibold mb-5">
              Analysis Overview
            </h1>
            <div className="flex justify-center items-center h-[300px] max-w-[500px] mx-auto mb-3">
              <img
                src={userData.photo}
                alt="User"
                className="h-[300px] w-[240px] object-cover rounded-xl bg-white"
              />
            </div>
            <div className="text-left">
              <h3 className="text-sm md:text-lg font-semibold">
                Your target points:
              </h3>
              <div className="flex items-start gap-2 max-w-[350px] text-sm mb-4">
                <img
                  src="/imgPredStar.svg"
                  alt="Skincare"
                  className="w-[20px] h-[20px] object-center flex-shrink-0"
                />
                <p className="text-left text-md">Rough texture</p>
              </div>
            </div>
            <div ref={sectionRef} className="flex -mx-1 mb-8">
              <Progress
                label="Hydration"
                value={animatedValues.hydration}
                color="bg-pinkCustom"
              />
              <Progress
                label="Elasticity"
                value={animatedValues.elasticity}
                color="bg-green-500"
              />
              <Progress
                label="Complexion"
                value={animatedValues.complexion}
                color="bg-purple-500"
              />
            </div>

            <div
              className={`relative overflow-hidden mb-8 transition-all duration-700 ${
                showFullReport ? "h-auto" : "h-[110px]"
              }`}
            >
              <div
                className={`space-y-4 text-left transition-opacity duration-700 ${
                  showFullReport ? "opacity-100" : "opacity-100"
                }`}
              >
                <p>
                  Your <span className="text-purple-500">Skin Hydration</span>{" "}
                  report indicates that your skin retains moisture well,
                  contributing to a plump and youthful appearance.
                </p>
                <p>
                  Your <span className="text-green-500">Skin Elasticity</span>{" "}
                  report indicates gradual improvement but could benefit from
                  targeted treatments.
                </p>
                <p>
                  Your <span className="text-pink-500">Complexion</span>{" "}
                  analysis shows an even tone with minor pigmentation spots.
                </p>
              </div>

              {/* Градиент исчезает при showFullReport */}
              {!showFullReport && (
                <div className="absolute bottom-0 left-0 h-16 w-full bg-gradient-to-t from-white to-transparent pointer-events-none transition-opacity duration-500" />
              )}
            </div>
            <div className="flex flex-col items-center justify-center gap-2 relative z-0 -mt-4">
              <img
                src="/lock-03.svg"
                alt="Lock icon"
                className="w-[20px] h-[20px] flex-shrink-0"
              />
              <p className="text-center text-md text-pink-500 font-bold">
                More data in the full report
              </p>
              <CustomBtn
                text={"Get My Full Report"}
                handleClick={() => scrollToSubscribe("analysis overview")}
              />
            </div>
          </div>
          <div className="mx-auto mb-5">
            <h1 className="text-lg md:text-xl font-semibold">
              Discover your best skincare matches
            </h1>
          </div>
          <SubscribePayment />
          <div className="mx-auto mb-3">
            <p className="text-left text-md line-clamp-none underline">
              30-day money-back guarantee
            </p>
          </div>
            <CustomBtn
              text={"Get My Plan"}
              handleClick={() => handleSubscribe()}
              isSelected={!userData.selectedOption}
            />
          
          <div className="flex justify-center px-4 xs:flex-row flex-col xs:items-stretch items-center mb-9">
            {/* Карточка 1 */}
            <div className="xs:w-[200px] w-full mb-2 rounded-2xl shadow-md bg-white p-4 xs:transform xs:rotate-[-7deg] flex xs:flex-col flex-row gap-4 items-center">
              <img
                src="/cream1.png"
                alt="Blue Peptides"
                className="h-[100px] w-[100px] object-cover flex-shrink-0"
              />
              <div className="flex flex-col h-full py-4">
                <p className="text-sm font-medium mb-2 leading-snug text-center xs:text-left">
                  Blue Peptides
                </p>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div
                    className="bg-green-400 h-2 rounded-full"
                    style={{ width: "97%" }}
                  ></div>
                  <p className="text-green-500 text-sm font-semibold ext-center xs:text-left">
                    97% fit
                  </p>
                </div>
              </div>
            </div>

            {/* Карточка 2 */}
            <div className="xs:w-[150px] w-full mb-2 rounded-2xl shadow-md bg-white p-4 flex xs:flex-col flex-row gap-4 items-center">
              <img
                src="/cream2.png"
                alt="Ultralight Face Fluid"
                className="h-[100px] w-[100px] object-cover flex-shrink-0"
              />
              <div className="flex-1">
                <p className="text-sm font-medium mb-2 leading-snug text-center xs:text-left">
                  Ultralight Face Fluid SPF 30
                </p>
                <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
                  <div
                    className="bg-green-400 h-2 rounded-full"
                    style={{ width: "100%" }}
                  ></div>
                </div>
                <p className="text-green-500 text-sm font-semibold text-center sm:text-left">
                  97% fit
                </p>
              </div>
            </div>

            {/* Карточка 3 */}
            <div className="xs:w-[250px] w-full rounded-2xl shadow-md mb-2 bg-white p-4 xs:transform xs:rotate-[7deg] flex xs:flex-col flex-row gap-4 items-center">
              <img
                src="/cream3.png"
                alt="Aquasource Hydra"
                className="h-[100px] w-[100px] object-cover flex-shrink-0"
              />
              <div className="flex flex-col h-full py-4">
                <p className="text-sm font-medium mb-2 leading-snug text-center xs:text-left">
                  Aquasource Hydra Barrier
                </p>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div
                    className="bg-red-600 h-2 rounded-full"
                    style={{ width: "25%" }}
                  ></div>
                  <p className="text-red-600 text-sm font-semibold text-center xs:text-left">
                    25% fit
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative overflow-visible mb-16 z-0">
            <div className="mx-auto mb-5 text-center">
              <h1 className="text-lg md:text-xl font-semibold mb-3">
                Other products fit
              </h1>
              <p className="text-center text-md ">
                Check out products that fit your skin best
              </p>
            </div>

            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              slidesPerView={2.2}
              autoplay={{ delay: 4000 }}
              className="!overflow-visible relative"
            >
              {creamData.map((item, idx) => (
                <SwiperSlide key={idx} className="!mr-1 w-auto">
                  <div className="w-full flex flex-col mb-2 rounded-2xl shadow-md bg-white p-4 items-center">
                    <img
                      src={item.img_url}
                      alt="Ultralight Face Fluid"
                      className="h-[100px] w-[100px] object-cover flex-shrink-0 blur-md"
                    />
                    <div className="flex flex-col justify-between flex-grow w-full">
                      <p className="text-sm font-medium mb-2 leading-snug text-center min-h-[60px] blur-sm">
                        {item.title}
                      </p>
                      <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
                        <div
                          className="bg-green-400 h-2 rounded-full"
                          style={{ width: `${item.percent}` }}
                        ></div>
                      </div>
                      <p className="text-green-500 text-sm font-semibold text-center">
                        {item.percent}% fit
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <CustomBtn
              text={"Get My Full Product List"}
              handleClick={() => scrollToSubscribe("other products")}
            />
          </div>
          <div className="relative mb-24">
            {/* Контент сверху */}
            <div className="relative z-10">
              <h1 className="text-lg md:text-xl font-semibold mb-3">
                Meghan Millton
              </h1>
              <p className="text-md">Solvi Medical Director, PhD</p>

              <div className="max-w-[250px] flex flex-col mb-2 rounded-2xl shadow-md bg-white p-4 items-center">
                <div className="flex flex-col justify-between">
                  <p className="text-sm">
                    Solvi knows what products will fit your skin best out of{" "}
                    <span className="font-bold">500K+ products</span> in our
                    database
                  </p>
                  <img
                    src="/signature.svg"
                    alt="Signature"
                    className="h-[70px] w-[70px] object-contain flex-shrink-0"
                  />
                </div>
              </div>
            </div>

            {/* Картинка снизу под контентом */}
            <img
              src="/women.jpg"
              alt="Woman"
              className="absolute left-[45%] w-[220px] object-cover z-0 pointer-events-none"
              style={{ top: "-70px" }}
            />

            {/* Полупрозрачный градиент снизу вверх */}
            <div className="absolute w-full h-10 z-10 pointer-events-none bg-gradient-to-t from-white via-white/80 to-transparent" />
          </div>
          <div className="flex flex-col items-center mb-9">
            <h1 className="text-lg md:text-xl font-semibold mb-3 text-center leading-snug">
              Get affordable dream skin without
              <br /> skincare confusion
            </h1>
            <button
              id={id2}
              key={id2}
              className="w-full bg-pink-200 mt-5 mb-12 rounded-full py-3 text-center font-semibold text-sm hover:bg-pink-300 transition"
              onClick={() => scrollToSubscribe("Introductory offer/last")}
            >
              Introductory offer expires in{" "}
              <span className="text-pink-600">{formatTime(secondsLeft)}</span>
            </button>
            <div className="relative w-[280px] h-64 xs:h-72 mb-12 mx-auto">
              {/* Нижнее изображение */}
              <img
                src="/img1.png"
                alt="Skincare"
                className="absolute top-[25px] transform -translate-x-1/2 h-full w-auto"
                style={{ right: 10 }}
              />
              {/* Верхнее изображение */}
              <img
                src="/img2.png"
                alt="Skincare"
                className="absolute top-0 transform -translate-x-1/2 h-full w-auto z-10"
                style={{ left: 220 }}
              />
              <img
                src="/arrow.svg"
                alt="Skincare"
                className="absolute top-[250px] left-[200px] xs:top-[275px] transform -translate-x-[150px] h-20 w-[200px] z-0"
                // style={{ left: 200, top: "275px" }}
              />
            </div>
            <CustomBtn
              text={"Get My Plan"}
              handleClick={() => scrollToSubscribe("affordable dream")}
            />
          </div>
          <div className="bg-white py-8 px-4">
            <h2 className="text-xl font-semibold text-center mb-6">
              Why Solvi?
            </h2>

            <div className="grid grid-cols-2 gap-4 max-w-md mx-auto">
              {dataReason.map((item) => (
                <div
                  key={item.title}
                  className="flex flex-col bg-white rounded-2xl p-4 shadow-xl"
                >
                  <div className="relative h-24 w-24 mb-2 mr-auto">
                    <img
                      src={item.img_url}
                      alt="Medical board"
                      className="h-full w-full object-cover rounded-lg"
                    />
                    <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-white to-transparent rounded-b-lg" />
                  </div>
                  <p className="text-sm font-medium">{item.title}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="bg-white py-5">
            <h2 className="text-xl font-semibold text-center mb-6">
              Get skin changing secrets
            </h2>

            <div className="flex flex-col gap-2 max-w-md mx-auto">
              {dataSecret.map((item, index) => (
                <div
                  key={index}
                  className={`flex gap-2 bg-white rounded-2xl p-4 shadow-xl ${
                    index % 2 === 1 ? "flex-row-reverse" : ""
                  }`}
                >
                  <img
                    src={item.img_url}
                    alt="Medical board"
                    className="h-[100px] w-[100px] object-cover rounded-lg"
                  />
                  <div className="flex flex-col items-start text-left">
                    <p className="text-sm text-pink-600">{item.type}</p>
                    <h3 className="text-xl font-semibold mb-3">{item.title}</h3>
                    <p className="text-sm text-gray-600">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <CustomBtn
              text={"Get My Full Product List"}
              handleClick={() => scrollToSubscribe("changing secrets")}
            />
          </div>
          <div className="bg-white py-8 mb-12">
            <div className="flex flex-col gap-2 bg-white rounded-2xl p-4 shadow-xl">
              <h2 className="text-xl font-semibold text-center mb-6">
                Gain insights from professional cosmetologists
              </h2>
              <img
                src="/womens.svg"
                alt="Medical board"
                className=" w-full object-contain rounded-lg"
              />
              <p className="text-sm text-gray-600 text-center">
                All our programs are created under thorough supervision by a
                team of Professional Cosmetologists, Cosmetic Chemists &
                Aesthetic Products Developers
              </p>
            </div>
          </div>
          <div className="relative mb-16 z-0">
            {/* Контент сверху */}
            <div className="relative flex items-center z-10">
              <img
                src="/gift.svg"
                alt="Signature"
                className="h-[45px] w-[45px] object-contain flex-shrink-0"
              />
              <h1 className="text-lg md:text-xl font-semibold mb-3">
                Your Lifetime Benefit:
              </h1>
            </div>
            <div className="relative max-w-[340px] flex flex-col mb-2 bg-white rounded-2xl shadow-md p-4 items-center z-10">
              <p className="text-sm">
                Solvi knows what products will fit your skin best out of{" "}
                <span className="font-bold">500K+ products</span> in our
                database
              </p>
            </div>

            {/* Картинка снизу под контентом */}
            <img
              src="/pig.svg"
              alt="Woman"
              className="absolute left-1/2 -translate-x-[-20px] w-[200px] object-cover z-0 pointer-events-none"
              style={{ top: "-70px" }}
            />
          </div>
          <div className="relative px-4 overflow-visible mb-12 z-0">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={16}
              slidesPerView={1.2}
              centeredSlides={true}
              autoplay={{ delay: 4000 }}
              className="!overflow-visible relative"
            >
              {reviews.map((review, idx) => (
                <SwiperSlide
                  key={idx}
                  className="!w-[280px] !h-[200px] flex-shrink-0"
                >
                  <div className="h-full p-4 bg-gray-50 rounded-lg shadow border flex flex-col justify-between">
                    <div>
                      <div className="flex justify-between items-center gap-2 mb-2">
                        <StarRating rating={review.rating} />
                        <div className="flex flex-col">
                          <span className="text-xs text-gray-500">
                            {review.date}
                          </span>
                          <span className="text-xs text-gray-500">
                            {review.city}
                          </span>
                        </div>
                      </div>
                      <h4 className="text-sm font-semibold mb-1">
                        {review.title}
                      </h4>
                      <p className="text-sm text-gray-700 line-clamp-4">
                        {review.text}
                      </p>
                    </div>
                    <div className="text-xs text-right text-gray-500 mt-2">
                      — {review.name}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className="mx-auto mb-5">
            <h1 className="text-lg md:text-xl font-semibold">
              Get Started with Special Pricing
            </h1>
          </div>
          <SubscribePayment />
          <div className="mx-auto mb-3">
            <p className="text-left text-md line-clamp-none underline">
              30-day money-back guarantee
            </p>
          </div>
            <CustomBtn
              text={"Get My Plan"}
              handleClick={() => handleSubscribe()}
              isSelected={!userData.selectedOption}
            />
          <div className="mb-12">
            <div className="max-w-[400px] mb-2 bg-white rounded-2xl shadow-md p-4 mx-auto">
              <div className="text-sm">
                This is an autorenewing subscription.
                <br />
                Your first payment is $19.99 as an introductory offer. All
                future payments of your Solvi Premium subscription will be
                automatically charged at the full price of $39.99 every month
                until you cancel the subscription. You can cancel the
                subscription via the Solvi app settings or breaching out to
                support at{" "}
                <a
                  href="mailto:support@solvi.club"
                  className="text-pink-600 underline"
                >
                  support@solvi.club
                </a>
                <br />
                Please note that this subscription is bound by Solvi{" "}
                <p className="text-sm text-gray-600">
                  <a
                    href="/privacy-policy"
                    className="text-pink-600 underline hover:text-pink-700"
                  >
                    Privacy Policy
                  </a>
                  ,{" "}
                  <a
                    href="/terms-of-use"
                    className="text-pink-600 underline hover:text-pink-700"
                  >
                    Terms of Use
                  </a>
                  , and{" "}
                  <a
                    href="/refund-policy"
                    className="text-pink-600 underline hover:text-pink-700"
                  >
                    Refund Policy
                  </a>
                  .
                </p>
              </div>
            </div>
            <div className="max-w-[400px] mb-2 bg-white rounded-2xl shadow-md p-4 mx-auto">
              <h1 className="text-lg md:text-xl font-semibold mb-3">
                Get Started with Special Pricing
              </h1>
              <p className="text-sm mb-3">
                We are confident in our service quality and its results. So, if
                you’re ready to reach your goals, it's a risk-free offer. We
                guarantee you'll see visible results, or you'll receive a full
                refund within 30 days of your purchase. You will need to
                demonstrate that you have followed the program.
              </p>
              <div className="flex items-center">
                <p className="text-sm mb-3">
                  Find more about the applicable limitations in our{" "}
                  <a
                    href="/refund-policy"
                    className="text-pink-600 underline hover:text-pink-700 cursor-pointer"
                  >
                    money-back guarantee policy
                  </a>
                </p>
                <img
                  src="/money.svg"
                  alt="Woman"
                  className="w-[80px] h-[80px] object-cover "
                />
              </div>
            </div>
            <div className="max-w-[400px] mb-2 bg-white rounded-2xl shadow-md p-4 mx-auto">
              <h1 className="text-lg md:text-xl font-semibold mb-3">
                Your information is safe
              </h1>
              <p className="text-sm mb-3">
                We will not sell or share your personal information for any
                marketing purposes
              </p>
            </div>
          </div>
          <div className="px-4">
            <h1 className="text-lg md:text-xl font-semibold mb-3">
              Need help?
            </h1>
            <p className="text-sm mb-3">
              Contact us here{" "}
              <a
                className="text-pink-600 underline hover:text-pink-700 cursor-pointer"
                href="mailto:support@solvi.club"
              >
                support@solvi.club
              </a>
            </p>
          </div>
        </div>
        {isOpen && (
          <PaymentModal
            isOpen={isOpen}
            onRequestClose={() => setModalOpen(!isOpen)}
          />
        )}
      </motion.div>
    </>
  );
}

function Progress({ label, value, color }) {
  return (
    <div className="w-1/2 px-1 mb-3">
      <div className="flex justify-between text-md font-bold mb-0.5">
        <span>{Math.round(value)}%</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-1.5">
        <div
          className={`h-1.5 rounded-full ${color}`}
          style={{ width: `${value}%` }} // без transition!
        />
      </div>
      <span>{label}</span>
    </div>
  );
}
